module.exports = __webpack_public_path__ + "media/images/blog/01-61adbdd0b8268b8cff1489b0ad1c9dee.jpg";